// extracted by mini-css-extract-plugin
module.exports = {"title_zing":"page404_title_zing__iLxMP","title_fnc":"page404_title_fnc__1vaPL"};